import store from '@/store/index'

export default {
  // check returns "error" if roles or permissions don't match or false if not
  check(record) {
    if (!store.getters['user/user'].roles) {
      return false
    }

    const roles = store.getters['user/user'].roles.map(role => role.name)
    const permissions = store.getters['user/permissions']

    if (typeof record.meta.auth !== 'object' || record.meta.auth === null) {
      return false
    }

    let auth = record.meta.auth

    if (auth.roles) {
      if (auth.roles.deny && auth.roles.deny.some(role => roles.indexOf(role) !== -1)) {
        return 'roles.deny'
      }
      if (auth.roles.allow && auth.roles.allow.some(role => roles.indexOf(role) === -1)) {
        return 'roles.allow'
      }
    }

    if (auth.permissions) {
      if (auth.permissions.deny && auth.permissions.deny.some(role => permissions.indexOf(role) !== -1)) {
        return 'permissions.deny'
      }
      if (auth.permissions.allow && auth.permissions.allow.some(role => permissions.indexOf(role) === -1)) {
        return 'permissions.allow'
      }
    }

    return false
  }
}
